import http from '@/environment/environment';
import { User, ApiKey } from '@/_models/User';
import store from '@/store/index';
export class UserService{

  async getUser(userId: string): Promise<User> {
    const fetchedUser = await http.get(`users/${userId}`);
    return fetchedUser.data;
  }

  async updateUser(userId: string, jwtToken: string, data: any): Promise<User> {
    http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    const fetchedUser = await http.put(`users/${userId}`, data);
    return fetchedUser.data;
  }

  async getGameApiKey(gameId: string):Promise<string>{
    const userObj = store.getters['auth/user'];
    const jwtToken = store.getters['auth/jwtToken']
    http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    try{
      const formData = new FormData();
      formData.append('pointerId', gameId);
      formData.append('hoursToExpire', '20');
      const fetchApiKey = await http.post(`apikeys?userId=${userObj.userId}`, formData);
      if(fetchApiKey.data.success){
        return fetchApiKey.data.viewModel.key;
      }
    }catch(err){
      console.log(err);
      return '';
    }
  }
}